/**
 * Returns true for ~600ms after a node last executed.
 * Pass `data._debugLastFired` (timestamp from EventRuntime).
 */
export function isFired(data) {
  return !!data?._debugLastFired && (Date.now() - data._debugLastFired) < 600
}
